// [BUTTON_IMPORTS_START]
import React from "react";
import Icon from "../icons/Icon";
import classes from "./Button.module.scss";

const Button = ({ text, onClick, textColor, color, width, height, iconName,IconClassName, iconSize = 32, style, className = "", borderColor }) => {

    return (
        <button
            type="button"
            className={`${classes.button} ${className}`}
            onClick={onClick}
            style={{ width: width, height: height, ...(style || {}), color: '#FFFFFF', background: color, borderColor: borderColor ? borderColor : color }}
        >
            {iconName && <Icon name={iconName} size={iconSize} className={IconClassName} />}
            {text && <span className={classes.text} style={{ color: textColor && textColor }}>{text}</span>}
        </button>
    );
};
export default Button
